const PLATFORM_ORDER = [
  'tiktok',
  'google',
  'meta',
  'linkedin',
  'dv360',
  'snapchat',
  'moloco',
  'applovin',
];

const UNRANKED = PLATFORM_ORDER.length;

function rankOf(slug: string): number {
  const rank = PLATFORM_ORDER.indexOf(slug.toLowerCase());
  return rank === -1 ? UNRANKED : rank;
}

export function byDisplayOrder<T extends { slug: string }>(platforms: T[]): T[] {
  return [...platforms].sort((left, right) => rankOf(left.slug) - rankOf(right.slug));
}
